import { EXTERNAL_INVOICE_ITALIAN } from '../constants/backend';
import { showPrivacyPolicy, showTOS, showTOU } from './components';

function formatItalianInvoiceParams(payload = {}, formValues = {}, companyData = {}) {
  const { useExternalInvoiceSystem } = companyData;
  const { italian, fiscalCode } = formValues;

  if (useExternalInvoiceSystem === EXTERNAL_INVOICE_ITALIAN) {
    if (italian) {
      payload.italianInvoicing = {
        italian: true,
        fiscalCode
      };
    } else {
      payload.italianInvoicing = {
        italian: false
      };
    }
  } else if (payload.italianInvoicing) {
    delete payload.italianInvoicing;
  }

  return payload;
}

function formatManagerEmail(payload = {}, formValues = {}, companyData = {}) {
  const { managerEmail } = formValues;
  const { sendEmailsToManager } = companyData;

  if (sendEmailsToManager) payload.managerEmail = managerEmail;

  return payload;
}

export function formatSpecialFieldsForApiCall(
  payload = {},
  formValues = {},
  companyData = {}
) {
  payload = { ...payload };
  payload = formatManagerEmail(payload, formValues, companyData);
  payload = formatItalianInvoiceParams(payload, formValues, companyData);

  return payload;
}

export function formatAcceptTermsForApiCall(payload, acceptTerms, registerCompany) {
  const {
    termsOfUse,
    termsOfSubscription,
    privacyPolicy,
    commercialPurposes
  } = acceptTerms;

  const data = {
    ...payload,
    commercialOffers: commercialPurposes,
    termsAndConditionsAcceptance: {
      termsOfUseAccepted: termsOfUse,
      termsOfSubscriptionAccepted: termsOfSubscription,
      privacyPolicyRead: privacyPolicy
    }
  };

  if (registerCompany) {
    const fields = data.termsAndConditionsAcceptance;

    if (!showTOU(registerCompany)) {
      delete fields.termsOfUseAccepted;
    }

    if (!showTOS(registerCompany)) {
      delete fields.termsOfSubscriptionAccepted;
    }

    if (!showPrivacyPolicy(registerCompany)) {
      delete fields.privacyPolicyRead;
    }
  }

  return data;
}

export function getErrorStatus(action) {
  const { error: errorResp } = action;
  const { response } = errorResp || {};
  const { status: errorStatus } = response || {};

  return errorStatus;
}



/** WEBPACK FOOTER **
 ** ./src/helpers/formatters.js
 **/